import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import './Login.css';
import { FcGoogle } from 'react-icons/fc';
import PrivacyBanner from './PrivacyBanner';
import RoutePlanningFlow from '../pages/RoutePlanningFlow';

const Login = () => {
  const { login } = useAuth();
  const [allowNecessary, setAllowNecessary] = useState(true);

  useEffect(() => {
    try {
      const raw = document.cookie.split('; ').find(c => c.startsWith('privacy_consent='));
      if (!raw) { setAllowNecessary(false); return; }
      const value = decodeURIComponent(raw.split('=')[1] || '');
      const parts = value.split(':');
      const necessary = parts.length >= 3 ? parts[1] === '1' : false;
      setAllowNecessary(necessary);
    } catch (_) {
      setAllowNecessary(false);
    }
  }, []);

  const handleLogin = async () => {
    try {
      if (!allowNecessary) {
        window.location.href = '/consent-required?returnTo=/login';
        return;
      }
      await login();
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h2 className="welcome-title">Welcome to LOOWAY</h2>
        <p className="subtitle">Plan accessible routes with confidence.</p>
        <button className="login-button" onClick={handleLogin} disabled={!allowNecessary}>
          <FcGoogle size={18} />
          Sign-in with Google
        </button>
        {!allowNecessary}
      </div>
      
      {/* Divider between sign-in and flowchart */}
      <div className="section-divider thick"></div>
      
      {/* Route Planning Flowchart */}
      <RoutePlanningFlow />
      
      {/* Divider between flowchart and privacy banner */}
      <div className="section-divider"></div>
      
      <PrivacyBanner />
    </div>
  );
};

export default Login; 